$(document).ready(function () {
  $('#newsroom-anchor-btn').click(function () {
    $('html, body').animate(
      {
        scrollTop: $('#newsroom-anchor').offset().top - 80,
      },
      500,
    );
  });
});
